import { jsxs as _jsxs } from "react/jsx-runtime";
import { Snackbar } from './errorBoundarySnackbar.styled';
export const ErrorBoundarySnackbar = ({ errorCount, onClick }) => (_jsxs(Snackbar, { onClick: onClick, children: ["Error(s) ", errorCount] }));
//# sourceMappingURL=errorBoundarySnackbar.js.map